<template lang="pug">
div.advancedSearch
  ods-form(
    :model='dataModel'
    :rules='searchRules'
    ref='advancedSearch'
    :show-message='true')
    ods-row(:gutter='32')
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.loyaltyAccount')" prop="loyaltyAccount")
          ods-input(v-model="dataModel.loyaltyAccount" :disabled="blockLoyaltyAccount")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.Idtype')" prop="tipidcli")
          ods-select(v-model="dataModel.tipidcli"
            :placeholder="loadingIds ? 'cagando' : !idDropdown ? 'Sin datos' : 'Seleccionar'"
            :disabled="blockIds || !idDropdown")
            ods-option(label="Seleccionar" value="")
            ods-option(
              v-for="item in idDropdown"
              :key="item.tipidcli"
              :label="item.desctidc"
              :value="item.tipidcli")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.identifier')" prop="idclient")
          ods-input(v-model="dataModel.idclient" :maxlength="20" :max="20" :disabled="blockIds")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.gender')" prop='sexo')
          br
          ods-radio-group(v-model='dataModel.sexo' :disabled="blockGender")
            ods-radio(label='V') {{ $t('loyalty.male') }}
            ods-radio(label='M') {{ $t('loyalty.female') }}
            ods-radio(label='N') {{ $t('loyalty.analytics.noinfo') }}

    ods-row(:gutter='32')
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.name')" prop="nombreid")
          ods-input(v-model="dataModel.nombreid" :maxlength="20" :max="20" :disabled="blockNames")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.firstName')" prop="apellid1")
          ods-input(v-model="dataModel.apellid1" :maxlength="20" :max="20" :disabled="blockNames")
      ods-col(:span='6')
        ods-form-item(:label="$t('loyalty.lastName')" prop="apellid2")
          ods-input(v-model="dataModel.apellid2" :maxlength="20" :max="20" :disabled="blockNames || !(dataModel.apellid1 && dataModel.nombreid)")
      ods-col(:span='6').actions
        ods-button(@click="limpiar" type="text" style='color: #DE2F2F') {{ $t('loyalty.clean')}}
        ods-button(@click="AplicarFiltros" type="primary") {{ $t('loyalty.apply') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Validator } from '@/utils/Validator.js'

export default {
  name: 'AdvancedSearchAsign',
  props: ['parametros'],
  data () {
    var validateText = (rule, value, callback) => {
      // console.log(`0 ${rule.field}: [${value}] obligado: [${rule.required}]`)
      setTimeout(() => { // loyaltyAccount
        if (rule.field === 'loyaltyAccount') {
          if (value) {
            this.blockIds = true
            this.blockGender = true
            this.blockNames = true
            Validator.phone(rule, value, callback)
          } else {
            this.blockIds = false
            this.blockGender = false
            this.blockNames = false
            Validator.phone(rule, value, callback)
          }
        } else if (rule.field === 'sexo') {
          if (value) {
            this.blockIds = true
            this.blockLoyaltyAccount = true
            this.blockNames = true
            callback()
          } else {
            this.blockIds = false
            this.blockLoyaltyAccount = false
            this.blockNames = false
            callback()
          }
        } else if (rule.field === 'nombreid') {
          if (value) {
            this.blockIds = true
            this.blockGender = true
            this.blockLoyaltyAccount = true
            Validator.names(rule, value, callback)
          } else {
            if (this.dataModel.apellid1) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockIds = false
              this.blockGender = false
              this.blockLoyaltyAccount = false
              callback()
            }
          }
        } else if (rule.field === 'apellid1') {
          if (value) {
            this.blockIds = true
            this.blockGender = true
            this.blockLoyaltyAccount = true
            Validator.names(rule, value, callback)
          } else {
            if (this.dataModel.nombreid) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockIds = false
              this.blockGender = false
              this.blockLoyaltyAccount = false
              callback()
            }
          }
        } else if (rule.field === 'apellid2') {
          Validator.names(rule, value, callback)
        } else if (rule.field === 'idclient') {
          if (value) {
            this.blockNames = true
            this.blockGender = true
            this.blockLoyaltyAccount = true
            Validator.docId(rule, value, callback)
          } else {
            if (this.dataModel.tipidcli) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockNames = false
              this.blockGender = false
              this.blockLoyaltyAccount = false
              callback()
            }
          }
        } else if (rule.field === 'tipidcli') {
          if (value) {
            this.blockNames = true
            this.blockGender = true
            this.blockLoyaltyAccount = true
            callback()
          } else {
            if (this.dataModel.idclient) {
              callback(new Error(this.$t('loyalty.requireField')))
            } else {
              this.blockNames = false
              this.blockGender = false
              this.blockLoyaltyAccount = false
              callback()
            }
          }
        }
      }, 200)
    }
    return {
      loadingIds: true,
      idDropdown: null,
      dataModel: this.getAdvancedSearch ? this.getAdvancedSearch : {},
      blockLoyaltyAccount: false,
      blockGender: false,
      blockNames: false,
      blockIds: false,
      searchRules: {
        loyaltyAccount: [{ required: false, validator: validateText }],
        sexo: [{ required: false, validator: validateText }],
        nombreid: [{ required: false, validator: validateText }],
        apellid1: [{ required: false, validator: validateText }],
        apellid2: [{ required: false, validator: validateText }],
        tipidcli: [{ required: false, validator: validateText }],
        idclient: [{ required: false, validator: validateText }]
      }
    }
  },
  computed: {
    ...mapGetters({
      nombre: 'getNombre',
      apellid1: 'getApellid1',
      apellid2: 'getApellid2',
      idclient: 'getIdclient',
      tipidcli: 'getTipidcli',
      getAdvancedSearch: 'getAdvancedSearch'
    })
  },
  created () {
    this.loadingIds = true
  },
  async mounted () {
    this.dataModel = await this.getAdvancedSearch
    console.log('this.dataModel', this.dataModel)
    const responseIds = this.getIdDropdown()
    responseIds.then(respIds => {
      this.idDropdown = Array.isArray(respIds.registros) ? respIds.registros : [respIds.registros]
      this.loadingIds = false
    }).catch(error => {
      console.log('error ids', error)
      this.loadingIds = false
    })
  },
  methods: {
    ...mapActions(['getIdDropdown', 'setAdvancedSearchFilters']),
    async handleValidate (formName) {
      // console.log('validate')
      this.$refs[formName].validate((valid) => {
        // console.log(valid)
        return valid
      })
    },
    async AplicarFiltros () {
      var params = {
        loyaltyAccount: this.dataModel.loyaltyAccount ? this.dataModel.loyaltyAccount : '',
        sexo: this.dataModel.sexo ? this.dataModel.sexo : '',
        nombreid: this.dataModel.nombreid ? this.dataModel.nombreid : '',
        apellid1: this.dataModel.apellid1 ? this.dataModel.apellid1 : '',
        apellid2: this.dataModel.apellid2 ? this.dataModel.apellid2 : '',
        idclient: this.dataModel.idclient ? this.dataModel.idclient : '',
        tipidcli: this.dataModel.tipidcli ? this.dataModel.tipidcli : ''
      }
      this.$refs.advancedSearch.validate((valid) => {
        if (valid) {
          // hacer mutation de las variables a llamar
          this.setAdvancedSearchFilters(this.dataModel)
          this.$emit('apply-advanced-search', params)
        } else {
          this.$notify({
            title: 'Mmmm...',
            message: 'Algo hay que revisar',
            type: 'error',
            offset: 150,
            duration: 2000
          })
        }
      })
    },
    limpiar () {
      this.dataModel = {}
      this.blockLoyaltyAccount = false
      this.blockGender = false
      this.blockNames = false
      this.blockIds = false
      this.$refs.advancedSearch.validate((valid) => {
        if (valid) {
          console.log('validado al limpiar')
        }
      })
      // this.$emit('clean-advanced-search')
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
.advancedSearch {
  background-color: #F9F9FB;
  padding: 20px;
}
ul.no-bullets {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pointer {
  cursor: pointer;
}
.flip {
  margin-top: -14px;
}
</style>
